/* global _BREAKPOINTS:readable */

export const theme = {
    breakpoints: _BREAKPOINTS,
};
export default class Breakpoints {
    static get height() {
        return window.innerHeight;
    }

    static get width() {
        return window.innerWidth;
    }

    static get mobileStartBreakpoint() {
        return theme.breakpoints.sm - 1;
    }

    static get mobileEndBreakpoint() {
        return theme.breakpoints.md - 1;
    }

    static get tabletStartBreakpoint() {
        return theme.breakpoints.md;
    }

    static isMobile(width) {
        return width <= Breakpoints.tabletEndBreakpoint;
    }

    static isMobileOnly(width) {
        return width <= Breakpoints.mobileEndBreakpoint;
    }

    static get tabletEndBreakpoint() {
        return theme.breakpoints.lg - 1;
    }

    static get desktopStartBreakpoint() {
        return theme.breakpoints.lg;
    }

    static get desktopEndBreakpoint() {
        return theme.breakpoints.xl - 1;
    }

    static get wideStartBreakpoint() {
        return theme.breakpoints.xl;
    }

    static get wideEndBreakpoint() {
        return theme.breakpoints.xxl - 1;
    }

    static get extraWideDevice() {
        return Breakpoints.width > Breakpoints.wideEndBreakpoint;
    }

    static get wideDevice() {
        return Breakpoints.width >= Breakpoints.wideStartBreakpoint;
    }

    static get desktopDevice() {
        return Breakpoints.width >= Breakpoints.desktopStartBreakpoint;
    }

    static get onlyTabletDevice() {
        return (
            Breakpoints.width >= Breakpoints.tabletStartBreakpoint &&
            Breakpoints.width <= Breakpoints.tabletEndBreakpoint
        );
    }

    static get tabletDevice() {
        // mobile + tablet
        return Breakpoints.width <= Breakpoints.tabletEndBreakpoint;
    }

    static get mobileDevice() {
        return Breakpoints.width <= Breakpoints.mobileEndBreakpoint;
    }

    static get currentDevice() {
        if (Breakpoints.desktopDevice) {
            return 'desktop';
        }
        if (Breakpoints.onlyTabletDevice) {
            return 'tablet';
        }
        return 'mobile';
    }
}
